// Copyright ©️ 2026 eVolve MEP, LLC

import { ColorField, type ColorFieldProps } from './ColorField';

/** Renders fill color + fill opacity controls for markups that support fills. */
export const FillColorField = (props: ColorFieldProps) => <ColorField {...props} />;
